var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layouts"},[_c('navbar',{staticClass:"fixed_nav",style:({background: `rgba(5, 32, 63, ${_vm.scrollProgress})`})}),_c('router-view'),_c('footerbar'),_c('BackTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }